import { Page } from "@/utils/getCurrentPage";

export const tabNames: Record<Page, string> = {
  stake: "Stake",
  unstake: "Unstake",
  account: "Account",
  earn: "Earn",
  tokens: "Tokens",
};
